<template>
  <a-card :bordered="false">
    <div class="card-title">{{ title }}</div>
    <a-spin :spinning="loading">
      <div class="table-operator">
      </div>
      <s-table
          ref="table"
          rowKey="vr_id"
          :loading="isLoading"
          :columns="columns"
          :data="loadData"
          :pageSize="15"
          :scroll="{y:500}"
      >
        <div slot="jyd" slot-scope="text, item">
          <b>{{ text == 0 ? '仓库' : '加油站' }}</b>
        </div>

        <div slot="jflx" slot-scope="text, item">
          <b v-if="item.jyd==1">{{ text == 0 ? '油卡加油' : '现金加油' }}</b>
        </div>
        <div slot="number" slot-scope="text, item">
          {{ text }}{{ item.tool_unit }}
        </div>
        <div slot="price" slot-scope="text, item">
          <span style="color: rgb(208, 5, 5)">￥</span>{{ text }}/{{ item.tool_unit }}
        </div>
        <div slot="total_amount" slot-scope="text, item">
          <span style="color: rgb(208, 5, 5)">￥</span>{{ text }}
        </div>

        <div slot="source" slot-scope="text, item">
          {{ text == 1 ? '后台' : '用户' }}
        </div>

        <div class="actions" slot="action" slot-scope="text, item">
          <a v-action:edit @click="handleEdit(item)">编辑</a>

          <a-popconfirm
              v-action:delete
              title="确认删除当前记录？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(item)"
          >
            <a href="#">删除</a>
          </a-popconfirm>
        </div>
      </s-table>
    </a-spin>
  </a-card>
</template>
<script>
import * as Api from '@/api/vehicle/refuelLog'
import {STable} from "@/components";
// import SearchForm from "./modules/SearchForm";
// import SaveForm from "./modules/SaveForm";
import pred from '@/views/vehicle/index/pre/Index.vue'

export default {
  props: ['vehicle_id'],
  name: "ShowToolList",
  components: {
    // SearchForm,
    // SaveForm,
    STable,
    pred
  },
  data() {
    return {
      title: '加油记录',
      queryParam: {
        vehicle_id: this.vehicle_id
      },
      visible: false,
      loading: false,
      isLoading: false,
      columns: [
        {
          title: '加油ID',
          dataIndex: 'vr_id',
          align: 'center',
          width: 60,
        },
        {
          title: '加油点',
          dataIndex: 'jyd',
          align: 'center',
          scopedSlots: {customRender: 'jyd'}
        },

        {
          title: '缴费类型',
          dataIndex: 'jflx',
          align: 'center',
          scopedSlots: {customRender: 'jflx'}
        },
        {
          title: '加油数量',
          dataIndex: 'jysl',
          align: 'center',
          scopedSlots: {customRender: 'number'}
        },
        {
          title: '加油金额',
          dataIndex: 'amount',
          align: 'center',
          scopedSlots: {customRender: 'total_amount'}
        },
        {
          title: '加油时间',
          dataIndex: 'create_time',
          align: 'center',
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: {customRender: 'action'}
        // },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      }
    }
  },
  methods: {
    open(vehicle_id, vehicle_name) {
      this.title = vehicle_name + ' - 加油记录'
      this.visible = true
      this.vehicle_id = vehicle_id
      this.$nextTick(() => {
        this.handleRefresh(true)
      })

    },
    cancel() {
      this.visible = false
    },

    /**
     * 添加
     */
    handleAdd() {
      this.$refs.SaveForm.add()
    },

    /**
     * 编辑
     */
    handleEdit(item) {
      this.$refs.SaveForm.edit(item)
    },

    handleDelete(item) {
      Api.deleted({vrId: item['vr_id']})
          .then((result) => {
            this.$message.success(result.message, 1.5)
            this.handleRefresh()
          })
    },

    /**
     * 搜索
     */
    handleSeachSubmit(value) {
      this.queryParam = {
        ...this.queryParam,
        ...value
      }
      this.handleRefresh(true)
    },


    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$refs.table.refresh(bool)
    },
  }
}
</script>
<style scoped lang="less">

</style>
